import {
  championshipTeamsDataSelector,
  championshipTeamsIsLoadedSelector,
  championshipTeamsIsLoadingSelector,
} from '../../store/championship/selectors';
import { useDispatch, useSelector } from 'react-redux';

import { fetchChampionshipTeams } from '../../store/championship/actions';
import { useChampionship } from './use-championship';
import { useEffect } from 'react';

export const useAcceptedChampionshipTeams = (championshipId: number) => {
  const dispatch = useDispatch();
  const { data: championship } = useChampionship(championshipId);
  const isLoading = useSelector(championshipTeamsIsLoadingSelector(championshipId));
  const isLoaded = useSelector(championshipTeamsIsLoadedSelector(championshipId));
  const teams = useSelector(championshipTeamsDataSelector(championshipId));

  useEffect(() => {
    if (!isLoaded && !isLoading && Boolean(championship)) {
      dispatch(fetchChampionshipTeams(championship.id));
    }
  }, [dispatch, championship, isLoaded, isLoading]);

  return {
    isLoading,
    isLoaded,
    teams,
  };
};
